var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6916 1.81668C10.4744 1.71764 10.2385 1.66638 9.99989 1.66638C9.76123 1.66638 9.52536 1.71764 9.30822 1.81668L2.16656 5.06668C2.01868 5.13188 1.89295 5.23868 1.80469 5.37406C1.71643 5.50944 1.66943 5.66757 1.66943 5.82918C1.66943 5.99079 1.71643 6.14892 1.80469 6.2843C1.89295 6.41968 2.01868 6.52648 2.16656 6.59168L9.31656 9.85001C9.53369 9.94905 9.76956 10.0003 10.0082 10.0003C10.2469 10.0003 10.4828 9.94905 10.6999 9.85001L17.8499 6.60001C17.9978 6.53481 18.1235 6.42801 18.2118 6.29263C18.3 6.15725 18.347 5.99913 18.347 5.83751C18.347 5.6759 18.3 5.51777 18.2118 5.38239C18.1235 5.24701 17.9978 5.14022 17.8499 5.07501L10.6916 1.81668Z",
    stroke: "#2E293D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 14.7083L10.6915 18.175C10.4744 18.274 10.2385 18.3253 9.99984 18.3253C9.76118 18.3253 9.52531 18.274 9.30817 18.175L1.6665 14.7083",
    stroke: "#2E293D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 10.5417L10.6915 14.0084C10.4744 14.1074 10.2385 14.1587 9.99984 14.1587C9.76118 14.1587 9.52531 14.1074 9.30817 14.0084L1.6665 10.5417",
    stroke: "#2E293D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.8c38a808f195825695ee679484549b70.svg";
export { ForwardRef as ReactComponent };